function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "c3ph3otpma",
  d: "M20.25 6.667s0-.084-.083-.084c0 0 0-.083-.084-.083l-2.5-3.333c-.083-.25-.333-.334-.583-.334H7c-.25 0-.5.084-.667.334L3.833 6.5s0 .083-.083.083c0 0 0 .084-.083.084v12c0 1.416 1.083 2.5 2.5 2.5h11.666c1.417 0 2.5-1.084 2.5-2.5V7c0-.083 0-.167-.083-.333zM7.417 4.5h9.166l1.25 1.667H6.167L7.417 4.5zm10.416 15H6.167c-.5 0-.834-.333-.834-.833V7.833h13.334v10.834c0 .5-.334.833-.834.833zm-1.666-9.167c0 2.334-1.834 4.167-4.167 4.167-2.333 0-4.167-1.833-4.167-4.167 0-.5.334-.833.834-.833.5 0 .833.333.833.833 0 1.417 1.083 2.5 2.5 2.5s2.5-1.083 2.5-2.5c0-.5.333-.833.833-.833.5 0 .834.333.834.833z"
}));
var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-1376.000000, -20.000000) translate(1376.000000, 20.000000)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "rk53eqz9yb",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#c3ph3otpma"
})), /*#__PURE__*/React.createElement("g", {
  fill: "#263238",
  mask: "url(#rk53eqz9yb)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0H24.24V24.24H0z"
})))));
function SvgShoppingBag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingBag);
export default __webpack_public_path__ + "static/media/shopping-bag.874ab7878484078e283c179cacc34b8c.svg";
export { ForwardRef as ReactComponent };